import { Link } from "react-router-dom";
import { CalendarDays, Users } from "lucide-react";
import { DailyCommissionItem } from "../../../../Redux/referral/types";
import { formatEarningsCurrency } from "../earningsAdapters";

interface Props {
  data: DailyCommissionItem[];
}

const DailyCommissonTable = ({ data }: Props) => {
  return (
    <div className="daily-ref-desktop-table-wrap">
      <table className="daily-ref-table daily-ref-summary-table">
        <colgroup>
          <col className="daily-ref-col-sno" />
          <col className="daily-ref-col-month" />
          <col className="daily-ref-col-contributors" />
          <col className="daily-ref-col-earned" />
        </colgroup>
        <thead>
          <tr>
            <th>S.NO</th>
            <th>MONTH - YEAR</th>
            <th>CONTRIBUTORS</th>
            <th>EARNED INCENTIVES</th>
            <th>TDS</th>
            <th>NET AMOUNT</th>
            <th>PENDING</th>
            <th>CANCELLED</th>
          </tr>
        </thead>
        <tbody>
          {(data || []).map((item, index) => (
            <tr key={index}>
              <td>
                <span className="daily-ref-sno-cell">{item.sNo}</span>
              </td>
              <td>
                <span className="daily-ref-month">
                  <CalendarDays size={15} />
                  <strong>{item.monthYear}</strong>
                </span>
              </td>
              <td>
                <Link
                  className="daily-ref-contributor-btn"
                  to={`/DailyCommissoinDetails?date=${item.monthYear}&code=${item.monthYearCode}`}
                >
                  <Users size={16} />
                  <strong>{item.contributors}</strong>
                  <span>View contributors</span>
                </Link>
              </td>
              <td>
                <strong className="daily-ref-earned">
                  {formatEarningsCurrency(item.grossAmount ?? item.receivedIncentives)}
                </strong>
              </td>
              <td>
                <strong className="daily-ref-earned">
                  {formatEarningsCurrency(item.tdsAmount ?? 0)}
                  {item.tdsIsEstimated ? " (est)" : ""}
                </strong>
              </td>
              <td>
                <strong className="daily-ref-earned">
                  {formatEarningsCurrency(item.netAmount ?? item.receivedIncentives)}
                </strong>
              </td>
              <td>
                <strong className="daily-ref-earned">
                  {formatEarningsCurrency(item.pendingIncentives)}
                </strong>
              </td>
              <td>
                <strong className="daily-ref-earned">
                  {formatEarningsCurrency(item.cancelledIncentives)}
                </strong>
              </td>
            </tr>
          ))}
          {(!data || data.length === 0) && (
            <tr>
              <td colSpan={8}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DailyCommissonTable;
